import { render, staticRenderFns } from "./EduExerciseExamRecord.vue?vue&type=template&id=39df8254&scoped=true&"
import script from "./EduExerciseExamRecord.vue?vue&type=script&lang=js&"
export * from "./EduExerciseExamRecord.vue?vue&type=script&lang=js&"
import style0 from "./EduExerciseExamRecord.vue?vue&type=style&index=0&id=39df8254&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39df8254",
  null
  
)

export default component.exports